import Modal from './Modal';

// Confirm dialog with a pending state on the confirm button.
export default function ConfirmDialog({ open, title = 'Are you sure?', message, confirmLabel = 'Delete', onConfirm, onCancel, pending }) {
  return (
    <Modal open={open} title={title} onClose={onCancel}>
      <p className="confirm__message">{message}</p>
      <div className="form__actions">
        <button className="btn btn--ghost" onClick={onCancel} disabled={pending}>Cancel</button>
        <button className="btn btn--danger" onClick={onConfirm} disabled={pending}>
          {pending ? 'Working…' : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
